export default __webpack_public_path__ + "static/media/EM0550.34I-41829_-25091_0.0efc87a9.jpg";